import { Directive, HostListener, OnInit, Signal } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ScriptInjectionService } from '../gtm-data-layer/script-injection.service';
import { AppConfigService } from '../../services/app-config.service';
import { AppModeService } from '../../services/app-mode.service';
import { DebugSection } from '../../models/debug-section';
import { PendingRequestsService } from '../../services/pending-requests.service';

@UntilDestroy()
@Directive()
export class BasePageComponent implements OnInit {
    public premiumViewed: boolean;
    public isBrowser: boolean;
    public assetsUrl: Signal<string>;
    public envDebugDrawer: Signal<boolean>;
    public displayHeader: boolean;
    public isMobile: boolean = false;
    public isFocused: boolean = false;
    public isPageScrolled: boolean = false;
    public debugSections: DebugSection[] = [];
    public showDebug: boolean;

    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {
        const scrollOffset = window.scrollY;
        this.isPageScrolled = scrollOffset > 0;
    }

    constructor(
        public readonly appConfig: AppConfigService,
        public readonly gtmService: ScriptInjectionService,
        public readonly appModeService: AppModeService,
        public readonly pendingRequestsService: PendingRequestsService,
    ) {}

    ngOnInit() {
        const env = this.appConfig.config();
        this.displayHeader = !this.appModeService.isAppMode();
        if (env.enableTrackingScripts === 'true') {
            this.gtmService.addScripts();
        }
    }

    onLogoClick() {
        window.open(this.appConfig.config()?.brandSiteUrl, '_blank');
    }

    /**
     * Warn the user if they try to refresh/leave the page that all their changes might not be saved yet.
     * This is to see if we can reduce how many times the users lose their data when they accidentally refresh the page.
     * Note: This does check if there are any active api requests, if there are none it will not show the warning.
     * @param event
     */
    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent): void {
        if (this.pendingRequestsService.hasPendingRequests()) {
            event.preventDefault();
        }
    }
}
